// TODO: Fix React 19 compiler lint errors. See https://react.dev/learn/react-compiler
/* eslint-disable react-hooks/set-state-in-effect */
import HeaderButtons from '@components/shared/Header/components/HeaderButtons';
import { GridColFullWidth } from '@constants/layout';
import type { MenuType } from '@lib/sanity/queries/menu/types';
import Container from '@ui/Container/Container';
import cn from '@utils/cn';
import { isDocumentDefined } from '@utils/validations';
import { HTMLAttributes, useLayoutEffect, useState } from 'react';
import { MenuBarHeight } from '../MenuBar';
import Link from './MenuCategory/Link';

export interface SectionProps extends Omit<HTMLAttributes<HTMLElement>, 'title'> {
  data?: MenuType | null;
  mobileCategories?: React.ReactElement[];
}

function MenuSectionMobile({ data, mobileCategories, className, ...rest }: SectionProps) {
  const [activeSection, setActiveSection] = useState<string | undefined | null>();
  const [height, setHeight] = useState<string>(`calc(100dvh - ${MenuBarHeight}px)`);

  useLayoutEffect(() => {
    if (!isDocumentDefined) {
      return;
    }
    const notificationBarHeight = document.getElementById('notification-bar')?.clientHeight ?? 0;
    if (notificationBarHeight) {
      setHeight(`calc(100dvh - ${notificationBarHeight + MenuBarHeight}px)`);
    }
  }, []);
  if (!data?.theme) {
    return;
  }
  if (!data?.menuSections?.length) {
    return;
  }

  return (
    <Container theme={data.theme} paddingType="none" style={{ height }}>
      <div className={cn('z-50 h-full w-full overflow-auto', GridColFullWidth, className)} {...rest}>
        {data.menuSections?.map((section, secIndex) => (
          <div key={secIndex} className="w-full">
            <Link
              isActive={!!section.title?.value && activeSection === section.title?.value}
              className="w-full"
              paddingsClassName="px-4 py-5 sm:px-8 md:pl-8 lg:px-0 lg:py-[29px]"
              onClick={() => {
                if (!section.menuCategories?.length) {
                  return;
                }
                if (activeSection === section.title?.value) {
                  setActiveSection(undefined);
                } else {
                  setActiveSection(section.title?.value);
                }
              }}
              title={section.title}
              menuCategories={section.menuCategories}
              url={section.url}
            ></Link>

            {section.title?.value &&
              activeSection === section.title.value &&
              mobileCategories?.length &&
              mobileCategories[secIndex]}
          </div>
        ))}
        <HeaderButtons
          buttonPrimary={data.buttonPrimary}
          buttonSecondary={data.buttonSecondary}
          className="flex w-full flex-col gap-4 p-4 sm:flex-row sm:p-8"
          buttonClassName="sm:w-full"
        />
      </div>
    </Container>
  );
}

export default MenuSectionMobile;
